import { render, staticRenderFns } from "./distributorFeeAllocation.vue?vue&type=template&id=c5354854&scoped=true"
import script from "./distributorFeeAllocation.vue?vue&type=script&lang=js"
export * from "./distributorFeeAllocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5354854",
  null
  
)

export default component.exports